import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ReplyIcon, DownloadIcon } from '@primer/octicons-react';
import axios from 'axios';
import Bookmark from './Bookmark';
import ModalShare from './ModalShare';
import './ReadonlyBookmarkCollection.css';

function ReadonlyBookmarkCollection() {
    const { id } = useParams();
    const [bookmarks, setBookmarks] = useState({});
    const [loggedIn, setLoggedIn] = useState(false);
    const [readonlyUuid, setReadonlyUuid] = useState(null);
    const [showShareModal, setShowShareModal] = useState(false);

    useEffect(() => {
        getBookmarks();
    }, [id]);

    const getBookmarks = () => {
        const path = '/api/robookmarks';
        const params = {
            collection_uuid: id,
        };

        axios.get(path, { params })
            .then((res) => {
                if (res.data.status === 'success') {
                    setBookmarks(res.data.bookmarks);
                    setLoggedIn(true);
                    setReadonlyUuid(id);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const showExportDialog = () => {
        const format = window.confirm('Export as Markdown? (Cancel for HTML)') ? 'markdown' : 'html';
        exportBookmarks(format);
    };

    const exportBookmarks = (format) => {
        const path = '/api/exportbookmarks';
        const params = {
            readonly_uuid: readonlyUuid,
            format: format
        };

        axios.get(path, { params })
            .then((res) => {
                if (res.data.status === 'fail') {
                    console.error(res.data.message);
                    return;
                }

                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;

                const ext = format === 'markdown' ? '.md' : '.' + format;
                link.setAttribute('download', bookmarks.title + ext);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    return (
        <div className="container">
            {loggedIn && <div className="bookmarksTitle">{bookmarks.title}</div>}
            {loggedIn && (
                <div className="bookmarksContainer">
                    {bookmarks.bookmarks && bookmarks.bookmarks.map((bookmark, index) => (
                        <Bookmark
                            key={index}
                            url={bookmark.url}
                            title={bookmark.title}
                            bookmarkId={bookmark.id}
                            editMode={false}
                        />
                    ))}
                    <div className="controls">
                        <div />
                        <span className="controlBtn" id="btnShare" onClick={() => setShowShareModal(true)}>
                            <ReplyIcon size={16} />&nbsp;Share
                        </span>
                        <span className="controlBtn" id="btnExport" onClick={showExportDialog}>
                            <DownloadIcon size={16} />&nbsp;Export
                        </span>
                    </div>
                </div>
            )}

            <ModalShare
                isOpen={showShareModal}
                onClose={() => setShowShareModal(false)}
                url={window.location.href}
                collectionUuid={readonlyUuid}
                readonly={true}
                readonlyEnabled={true}
            />

            {!loggedIn && <div className="blankPrompt">No bookmarks to show</div>}
        </div>
    );
}

export default ReadonlyBookmarkCollection;
